import React, { useEffect, useState, useRef } from "react";
import { DataGrid, gridClasses, GridMoreVertIcon } from "@mui/x-data-grid";
import {
  Box,
  IconButton,
  styled,
  MenuItem,
  Popover,
  Button,
  TextField,
  Select,
  FormControl,
  InputLabel,
  Modal,
} from "@mui/material";
import { CiEdit } from "react-icons/ci";
import { HttpService } from "../../service/HttpService";
import FullScreenLoader from "../../components/Loader/FullScreenLoader";
import { toast } from "react-toastify";
import MatricIdsListModal from "../../components/Model/MatricIdsListModal";
import { useAuth } from "../../context/AuthProvider";
import { MdArchive, MdClose } from "react-icons/md";
import { RxPlus, RxCross1 } from "react-icons/rx";
import { GoTrash } from "react-icons/go";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TbAlertHexagonFilled } from "react-icons/tb";
import "./Harvest.scss";
import moment from "moment/moment";

const formatFloat = (value) => {
  // const num = parseFloat(value);
  // if (isNaN(num)) return 0;
  // return num % 1 === 0 ? num : num.toFixed(2);
  const num = parseFloat(value);
  if (isNaN(num)) return 0;
  return num.toFixed(2);
};

const getWeekOfYear = (date) => {
  const d = new Date(date);
  const yearStart = new Date(d.getFullYear(), 0, 1);
  const weekNumber = Math.ceil(
    ((d - yearStart) / 86400000 + yearStart.getDay() + 1) / 7,
  );
  return weekNumber;
};

const Harvest = ({ hideHeader }) => {
  const { setShowLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const [loading, setLoading] = useState(false);
  const [priceData, setPriceData] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editValues, setEditValues] = useState({});
  const [harvestData, setHarvestData] = useState([]);
  const [editingHarvestId, setEditingHarvestId] = useState(null);
  const [editHarvestValues, setEditHarvestValues] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRowId, setMenuRowId] = useState(null);
  const [cultivars, setCultivars] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [debounceTimers, setDebounceTimers] = useState({});
  const [archiveModalOpen, setArchiveModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedArchiveId, setSelectedArchiveId] = useState(null);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  const [archivingType, setArchivingType] = useState("harvest");
  const [deletingType, setDeletingType] = useState("harvest");

  // Fresh Frozen states
  const [frozenHarvestData, setFrozenHarvestData] = useState([]);
  const [isFrozenLoading, setIsFrozenLoading] = useState(false);
  const [editingFrozenHarvestId, setEditingFrozenHarvestId] = useState(null);
  const [editFrozenHarvestValues, setEditFrozenHarvestValues] = useState({});
  const gridContainerRef = useRef(null);
  const frozenGridContainerRef = useRef(null);
  const editHarvestValuesRef = useRef(editHarvestValues);
  const editingHarvestIdRef = useRef(editingHarvestId);
  const editFrozenHarvestValuesRef = useRef(editFrozenHarvestValues);
  const editingFrozenHarvestIdRef = useRef(editingFrozenHarvestId);

  // Keep refs in sync with state for use in event listeners
  const [matricModalOpen, setMatricModalOpen] = useState(false);
  const [selectedMatricRow, setSelectedMatricRow] = useState(null);

  const handleOpenMatricModal = (row) => {
    setSelectedMatricRow(row);
    setMatricModalOpen(true);
  };

  useEffect(() => {
    editHarvestValuesRef.current = editHarvestValues;
  }, [editHarvestValues]);

  useEffect(() => {
    editingHarvestIdRef.current = editingHarvestId;
  }, [editingHarvestId]);

  useEffect(() => {
    editFrozenHarvestValuesRef.current = editFrozenHarvestValues;
  }, [editFrozenHarvestValues]);

  useEffect(() => {
    editingFrozenHarvestIdRef.current = editingFrozenHarvestId;
  }, [editingFrozenHarvestId]);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     // Check if clicking outside the grid AND outside any popovers/datepickers/modals
  //     const isPopover = !!document.querySelector(
  //       ".MuiPopover-root, .MuiDialog-root, .MuiDateCalendar-root, .MuiPickersPopper-root, .MuiPickersLayout-root",
  //     );

  //     const currentId = editingHarvestIdRef.current;
  //     if (!currentId || isPopover) return;

  //     // Skip logic if the click target is no longer in the document (detached during re-render)
  //     if (!document.body.contains(event.target)) return;

  //     // Ignore clicks on the DataGrid scrollbar area
  //     const scrollContainer = event.target.closest(
  //       ".MuiDataGrid-virtualScroller",
  //     );
  //     if (scrollContainer) {
  //       const rect = scrollContainer.getBoundingClientRect();
  //       // If click is on the scrollbar (beyond the visible content area)
  //       if (
  //         event.clientX >= rect.right - 20 ||
  //         event.clientY >= rect.bottom - 20
  //       ) {
  //         return;
  //       }
  //     }

  //     // Also ignore clicks on DataGrid header, footer, or overlay areas
  //     if (
  //       event.target.closest(
  //         ".MuiDataGrid-columnHeaders, .MuiDataGrid-footerContainer, .MuiDataGrid-overlay",
  //       )
  //     ) {
  //       return;
  //     }

  //     // Find the specific row element being edited using standard DataGrid selector
  //     const editingRow = document.querySelector(
  //       `.MuiDataGrid-row[data-id="${currentId}"]`,
  //     );

  //     if (editingRow && !editingRow.contains(event.target)) {
  //       // handleSaveHarvest(editHarvestValuesRef.current);
  //     } else if (
  //       editingRow &&
  //       !editingRow.contains(event.target) &&
  //       gridContainerRef.current &&
  //       !gridContainerRef.current.contains(event.target)
  //     ) {
  //       handleSaveHarvest(editHarvestValuesRef.current);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);
  useEffect(() => {
    const isHarvestRowEmpty = (row) => {
      if (!row) return true;
      return (
        (row.cultivar_id === 0 || !row.cultivar_id) &&
        (row.room_id === 0 || !row.room_id) &&
        row.harvest_date === null &&
        Number(row.wet_weight || 0) === 0 &&
        Number(row.weight_after_bucking || 0) === 0 &&
        Number(row.plants || 0) === 0 &&
        Number(row.bulk_lbs || 0) === 0 &&
        Number(row.smalls_lbs || 0) === 0 &&
        Number(row.trim_lbs || 0) === 0 &&
        Number(row.waste || 0) === 0
      );
    };

    const handleClickOutside = (event) => {
      const currentId = editingHarvestIdRef.current;
      const currentValues = editHarvestValuesRef.current;
      const currentFrozenId = editingFrozenHarvestIdRef.current;
      const currentFrozenValues = editFrozenHarvestValuesRef.current;

      // Ignore popovers, dialogs, pickers
      const isPopover = !!event.target.closest(
        ".MuiPopover-root, .MuiDialog-root, .MuiPickersPopper-root, .MuiPickersLayout-root",
      );
      if (isPopover) return;

      // Ignore detached elements
      if (!document.body.contains(event.target)) return;

      // Handle main harvest table click outside
      if (currentId && currentValues && Object.keys(currentValues).length > 0) {
        const isInsideHarvest = event.target.closest(
          `.MuiDataGrid-row[data-id="${currentId}"], input, textarea, select, .MuiSelect-select`,
        );
        if (!isInsideHarvest) {
          if (!isHarvestRowEmpty(currentValues)) {
            handleSaveHarvest(currentValues);
          } else {
            handleCancelHarvest();
          }
        }
      }

      // Handle frozen harvest table click outside
      if (
        currentFrozenId &&
        currentFrozenValues &&
        Object.keys(currentFrozenValues).length > 0
      ) {
        const isInsideFrozen = event.target.closest(
          `.MuiDataGrid-row[data-id="${currentFrozenId}"], input, textarea, select, .MuiSelect-select`,
        );
        if (!isInsideFrozen) {
          // If row is empty, cancel; otherwise save
          const isFrozenRowEmpty = (row) => {
            if (!row) return true;
            return (
              (row.cultivar_id === 0 || !row.cultivar_id) &&
              (row.room_id === 0 || !row.room_id) &&
              row.harvest_date === null &&
              Number(row.wet_weight || 0) === 0 &&
              Number(row.plants || 0) === 0 &&
              Number(row.waste || 0) === 0 &&
              Number(row.fresh_frozen_grams || 0) === 0 &&
              Number(row.rosin_grams || 0) === 0
            );
          };

          if (!isFrozenRowEmpty(currentFrozenValues)) {
            handleSaveFrozenHarvest(currentFrozenValues);
          } else {
            handleCancelFrozenHarvest();
          }
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchPriceConfig = async () => {
    setLoading(true);
    try {
      const response = await httpService.get("harvest/price-config");
      if (response?.data) {
        setPriceData([{ ...response.data }]);
      }
    } catch (error) {
      setPriceData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchHarvestData = async () => {
    setLoading(true);
    try {
      const response = await httpService.get("harvest");
      if (response?.data) {
        setHarvestData(response.data);
      }
    } catch (error) {
      setHarvestData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchFrozenHarvestData = async () => {
    setIsFrozenLoading(true);
    try {
      const response = await httpService.get("harvest/fresh-frozen");
      if (response?.data) {
        setFrozenHarvestData(response.data);
      }
    } catch (error) {
      setFrozenHarvestData([]);
    } finally {
      setIsFrozenLoading(false);
    }
  };

  const fetchDropdownData = async () => {
    try {
      const [cultivarRes, roomRes] = await Promise.all([
        httpService.get("plant/get_plant"),
        httpService.get("rooms"),
      ]);
      setCultivars(cultivarRes?.data?.data || []);
      setRooms(roomRes?.data?.data || []);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  useEffect(() => {
    fetchPriceConfig();
    fetchHarvestData();
    fetchFrozenHarvestData();
    fetchDropdownData();
  }, []);

  useEffect(() => {
    return () => {
      Object.values(debounceTimers).forEach((timer) => clearTimeout(timer));
    };
  }, [debounceTimers]);

  const handleEdit = (row) => {
    setEditingId(row.id);
    setEditValues({
      bulk_price: row.bulk_price,
      smalls_price: row.smalls_price,
      trim_price: row.trim_price,
    });
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditValues({});
    fetchPriceConfig();
  };

  const handleFieldChange = async (field, value) => {
    const updatedData = { ...editValues, [field]: value };
    setEditValues(updatedData);

    // Clear existing timer whenever any field changes
    if (debounceTimers.priceUpdate) {
      clearTimeout(debounceTimers.priceUpdate);
    }

    // Set new timer - only saves after 2 seconds of no activity on any field
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        await httpService.put("harvest/price-config", {
          bulk_price: parseFloat(updatedData.bulk_price) || 0,
          smalls_price: parseFloat(updatedData.smalls_price) || 0,
          trim_price: parseFloat(updatedData.trim_price) || 0,
        });
        toast.success("Price updated successfully");
        fetchPriceConfig();
      } catch (error) {
        toast.error("Failed to update price");
      } finally {
        setLoading(false);
      }
    }, 3000); // 2 second delay after last edit

    setDebounceTimers((prev) => ({ ...prev, priceUpdate: timer }));
  };

  const handleAddHarvest = () => {
    const newRow = {
      id: `new_${Date.now()}`,
      week_of_harvest: 0,
      harvest_date: null,
      cultivar_id: 0,
      room_id: 0,
      plants: 0,
      wet_weight: 0,
      waste: 0,
      weight_after_bucking: 0,
      bulk_lbs: 0,
      smalls_lbs: 0,
      trim_lbs: 0,
      isNew: true,
    };
    setHarvestData([newRow, ...harvestData]);
    setEditingHarvestId(newRow.id);
    setEditHarvestValues(newRow);
  };

  const handleEditHarvest = async (row) => {
    setEditingHarvestId(row.id);
    setEditHarvestValues({ ...row });
    if (row.harvest_date) {
      try {
        const response = await httpService.get(
          `harvest/room-cultivar?harvestedDate=${moment(row.harvest_date).format("YYYY-MM-DD")}`,
        );
        if (
          response?.data?.rooms?.length > 0 ||
          response?.data?.cultivars?.length > 0
        ) {
          setRooms(response.data.rooms || []);
          setCultivars(response.data.cultivars || []);
        } else {
          setRooms([]);
          setCultivars([]);
        }
      } catch (error) {
        console.error("Error fetching room/cultivar data:", error);
      }
    } else {
      fetchDropdownData();
    }
  };

  const handleCancelHarvest = () => {
    setEditingHarvestId(null);
    setEditHarvestValues({});
    setRooms([]);
    setCultivars([]);
    fetchHarvestData();
  };

  const checkAllFieldsFilled = (values) => {
    const requiredFields = [
      "week_of_harvest",
      "harvest_date",
      "cultivar_id",
      "room_id",
      "plants",
      "wet_weight",
      "waste",
      "weight_after_bucking",
      "bulk_lbs",
      "smalls_lbs",
      "trim_lbs",
    ];

    return requiredFields.every((field) => {
      const val = values[field];
      return val !== null && val !== undefined && val !== "" && val !== 0;
    });
  };

  const handleHarvestFieldChange = async (
    field,
    value,
    saveImmediately = false,
  ) => {
    let updatedValues = field
      ? { ...editHarvestValues, [field]: value }
      : editHarvestValues;

    // Skip update logic if purely saving existing state
    if (field) {
      // Auto-calculate week of harvest when harvest date changes
      if (field === "harvest_date" && value) {
        const weekNumber = getWeekOfYear(value);
        updatedValues = { ...updatedValues, week_of_harvest: weekNumber };

        // Fetch rooms and cultivars for the new date
        try {
          const response = await httpService.get(
            `harvest/room-cultivar?harvestedDate=${value}`,
          );
          if (response?.data) {
            setRooms(response.data.rooms || []);
            setCultivars(response.data.cultivars || []);
            updatedValues = {
              ...updatedValues,
              room_id: null,
            };
            updatedValues = {
              ...updatedValues,
              cultivar_id: null,
            };
          }
        } catch (error) {
          console.error("Error fetching room/cultivar data:", error);
          setRooms([]);
          setCultivars([]);
        }
      }

      // Auto-fetch plant count when cultivar or room changes
      if (
        (field === "cultivar_id" || field === "room_id") &&
        updatedValues.cultivar_id &&
        updatedValues.room_id &&
        updatedValues.harvest_date
      ) {
        try {
          const response = await httpService.get(
            `harvest/plant-count?plantId=${updatedValues.cultivar_id}&roomId=${updatedValues.room_id}&harvestedDate=${updatedValues.harvest_date}`,
          );
          const count =
            response?.data?.count ?? response?.data?.data ?? response?.data;
          if (count !== undefined && count !== null) {
            updatedValues = { ...updatedValues, plants: parseInt(count) || 0 };
          }
        } catch (error) {
          console.error("Error fetching plant count:", error);
        }
      }
    }

    if (editHarvestValues.isNew) {
      setEditHarvestValues(updatedValues);

      // Clear existing timer for saving
      // if (debounceTimers.harvestSave) {
      //   clearTimeout(debounceTimers.harvestSave);
      // }

      // if (saveImmediately) {
      //   handleSaveHarvest(updatedValues);
      // } else {
      //   // Set new timer for auto-save check
      //   const timer = setTimeout(() => {
      //     handleSaveHarvest(updatedValues);
      //   }, 8000);
      //   setDebounceTimers((prev) => ({ ...prev, harvestSave: timer }));
      // }
    } else {
      setEditHarvestValues(updatedValues);

      // if (debounceTimers.harvestUpdate) {
      //   clearTimeout(debounceTimers.harvestUpdate);
      // }

      // const currentEditingId = editingHarvestId;
      // const currentValues = updatedValues;

      // const performUpdate = async () => {
      // setLoading(true);
      // try {
      //   const payload = {
      //     price_config_id: priceData[0]?.id,
      //     week_of_harvest: parseInt(currentValues.week_of_harvest) || 0,
      //     harvest_date: currentValues.harvest_date,
      //     cultivar_id: parseInt(currentValues.cultivar_id) || 0,
      //     room_id: parseInt(currentValues.room_id) || 0,
      //     plants: parseInt(currentValues.plants) || 0,
      //     wet_weight: parseFloat(currentValues.wet_weight) || 0,
      //     waste: parseFloat(currentValues.waste) || 0,
      //     weight_after_bucking: parseFloat(currentValues.weight_after_bucking) || 0,
      //     bulk_lbs: parseFloat(currentValues.bulk_lbs) || 0,
      //     smalls_lbs: parseFloat(currentValues.smalls_lbs) || 0,
      //     trim_lbs: parseFloat(currentValues.trim_lbs) || 0,
      //   };

      //   await httpService.put(`harvest/${currentEditingId}`, payload);
      //   toast.success("Harvest updated successfully");
      //   fetchHarvestData();
      //   setEditingHarvestId(null);
      //   setEditHarvestValues({});
      // } catch (error) {
      //   toast.error("Failed to update harvest");
      // } finally {
      //   setLoading(false);
      // }
      // };

      // if (saveImmediately) {
      //   performUpdate();
      // } else {
      //   const timer = setTimeout(performUpdate, 8000);
      //   setDebounceTimers((prev) => ({ ...prev, harvestUpdate: timer }));
      // }
    }
  };

  const handleSaveHarvest = async (valuesToSave) => {
    setLoading(true);
    // setDebounceTimers({});
    try {
      const currentValues = valuesToSave || editHarvestValues;
      const currentId = editingHarvestIdRef.current || editingHarvestId;
      const isNew = currentValues.isNew || String(currentId).startsWith("new_");

      const payload = {
        price_config_id: priceData[0]?.id,
        week_of_harvest: parseInt(currentValues.week_of_harvest) || 0,
        harvest_date: dayjs(currentValues.harvest_date).format("YYYY-MM-DD"),
        cultivar_id: parseInt(currentValues.cultivar_id) || 0,
        room_id: parseInt(currentValues.room_id) || 0,
        plants: parseInt(currentValues.plants) || 0,
        wet_weight: parseFloat(currentValues.wet_weight) || 0,
        waste: parseFloat(currentValues.waste) || 0,
        weight_after_bucking:
          parseFloat(currentValues.weight_after_bucking) || 0,
        bulk_lbs: parseFloat(currentValues.bulk_lbs) || 0,
        smalls_lbs: parseFloat(currentValues.smalls_lbs) || 0,
        trim_lbs: parseFloat(currentValues.trim_lbs) || 0,
      };

      if (isNew) {
        await httpService.post("harvest", payload);
        toast.success("Harvest added successfully");
      } else {
        await httpService.put(`harvest/${currentId}`, payload);
        toast.success("Harvest updated successfully");
      }
      setEditingHarvestId(null);
      setEditHarvestValues({});
      fetchHarvestData();
    } catch (error) {
      toast.error(
        editHarvestValues.isNew
          ? "Failed to save harvest"
          : "Failed to update harvest",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleArchiveHarvest = async (id) => {
    setLoading(true);
    try {
      await httpService.put(`harvest/archive/${id}`);
      toast.success("Harvest archived successfully");
      fetchHarvestData();
    } catch (error) {
      toast.error("Failed to archive harvest");
    } finally {
      setLoading(false);
    }
  };

  const handleArchiveFrozenHarvest = async (id) => {
    setLoading(true);
    try {
      await httpService.put(`harvest/fresh-frozen/archive/${id}`);
      toast.success("Fresh Frozen Harvest archived successfully");
      fetchFrozenHarvestData();
    } catch (error) {
      toast.error("Failed to archive fresh frozen harvest");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteHarvest = async (id) => {
    setLoading(true);
    try {
      await httpService.delete(`harvest/delete/${id}`);
      toast.success("Harvest deleted successfully");
      fetchHarvestData();
    } catch (error) {
      toast.error("Failed to delete harvest");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteFrozenHarvest = async (id) => {
    setIsFrozenLoading(true);
    try {
      await httpService.delete(`harvest/fresh-frozen/delete/${id}`);
      toast.success("Fresh Frozen Harvest deleted successfully");
      fetchFrozenHarvestData();
    } catch (error) {
      toast.error("Failed to delete fresh frozen harvest");
    } finally {
      setIsFrozenLoading(false);
    }
  };

  const handleArchiveAllFrozen = async () => {
    const allIds = frozenHarvestData.map((row) => row.id);
    if (allIds.length === 0) {
      toast.error("No fresh frozen harvests to archive");
      return;
    }
    setLoading(true);
    try {
      await httpService.put("harvest/fresh-frozen/archive", { ids: allIds });
      toast.success("All Fresh Frozen harvests archived successfully");
      fetchFrozenHarvestData();
    } catch (error) {
      toast.error("Failed to archive fresh frozen harvests");
    } finally {
      setLoading(false);
    }
  };

  const handleArchiveAll = async () => {
    const allIds = harvestData.map((row) => row.id);
    if (allIds.length === 0) {
      toast.error("No harvests to archive");
      return;
    }
    setLoading(true);
    try {
      await httpService.put("harvest/archive", { ids: allIds });
      toast.success("All harvests archived successfully");
      fetchHarvestData();
    } catch (error) {
      toast.error("Failed to archive harvests");
    } finally {
      setLoading(false);
    }
  };

  const handleAddFrozenHarvest = () => {
    const newRow = {
      id: `new_frozen_${Date.now()}`,
      week_of_harvest: 0,
      harvest_date: null,
      cultivar_id: 0,
      room_id: 0,
      plants: 0,
      wet_weight: 0,
      waste: 0,
      fresh_frozen_grams: 0,
      rosin_grams: 0,
      yield: 0,
      isNew: true,
    };
    setFrozenHarvestData([newRow, ...frozenHarvestData]);
    setEditingFrozenHarvestId(newRow.id);
    setEditFrozenHarvestValues(newRow);
  };

  const handleEditFrozenHarvest = (row) => {
    setEditingFrozenHarvestId(row.id);
    setEditFrozenHarvestValues({ ...row });
  };

  const handleCancelFrozenHarvest = () => {
    setEditingFrozenHarvestId(null);
    setEditFrozenHarvestValues({});
    fetchFrozenHarvestData();
  };

  const handleFrozenHarvestFieldChange = async (
    field,
    value,
    saveImmediately = false,
  ) => {
    let updatedValues = field
      ? { ...editFrozenHarvestValues, [field]: value }
      : editFrozenHarvestValues;

    if (field) {
      if (field === "harvest_date" && value) {
        const weekNumber = getWeekOfYear(value);
        updatedValues = { ...updatedValues, week_of_harvest: weekNumber };

        try {
          const response = await httpService.get(
            `harvest/room-cultivar?harvestedDate=${value}`,
          );
          if (response?.data) {
            setRooms(response.data.rooms || []);
            setCultivars(response.data.cultivars || []);
            updatedValues = {
              ...updatedValues,
              room_id: null,
              cultivar_id: null,
            };
          }
        } catch (error) {
          console.error("Error fetching room/cultivar data:", error);
        }
      }

      if (
        (field === "cultivar_id" || field === "room_id") &&
        updatedValues.cultivar_id &&
        updatedValues.room_id &&
        updatedValues.harvest_date
      ) {
        try {
          const response = await httpService.get(
            `harvest/plant-count?plantId=${updatedValues.cultivar_id}&roomId=${updatedValues.room_id}&harvestedDate=${updatedValues.harvest_date}`,
          );
          const count =
            response?.data?.count ?? response?.data?.data ?? response?.data;
          if (count !== undefined && count !== null) {
            updatedValues = { ...updatedValues, plants: parseInt(count) || 0 };
          }
        } catch (error) {
          console.error("Error fetching plant count:", error);
        }
      }
    }

    setEditFrozenHarvestValues(updatedValues);

    if (
      saveImmediately &&
      !editingFrozenHarvestIdRef.current?.startsWith("new_frozen_")
    ) {
      handleSaveFrozenHarvest(updatedValues);
    }
  };

  const handleSaveFrozenHarvest = async (valuesToSave) => {
    setIsFrozenLoading(true);
    try {
      const currentValues = valuesToSave || editFrozenHarvestValues;
      const currentId =
        editingFrozenHarvestIdRef.current || editingFrozenHarvestId;
      const isNew =
        String(currentId).startsWith("new_frozen_") || currentValues.isNew;

      const payload = {
        week_of_harvest: parseInt(currentValues.week_of_harvest) || 0,
        harvest_date: dayjs(currentValues.harvest_date).format("YYYY-MM-DD"),
        cultivar_id: parseInt(currentValues.cultivar_id) || 0,
        room_id: parseInt(currentValues.room_id) || 0,
        plants: parseInt(currentValues.plants) || 0,
        wet_weight: parseFloat(currentValues.wet_weight) || 0,
        waste: parseFloat(currentValues.waste) || 0,
        fresh_frozen_grams: parseFloat(currentValues.fresh_frozen_grams) || 0,
        rosin_grams: parseFloat(currentValues.rosin_grams) || 0,
        yield: parseFloat(currentValues.yield) || 0,
      };

      if (isNew) {
        await httpService.post("harvest/fresh-frozen", payload);
        toast.success("Fresh Frozen Harvest added successfully");
      } else {
        await httpService.put(`harvest/fresh-frozen/${currentId}`, payload);
        toast.success("Fresh Frozen Harvest updated successfully");
      }
      setEditingFrozenHarvestId(null);
      setEditFrozenHarvestValues({});
      fetchFrozenHarvestData();
    } catch (error) {
      toast.error("Failed to save fresh frozen harvest");
    } finally {
      setIsFrozenLoading(false);
    }
  };

  const handleMenuClickFrozen = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(rowId);
  };

  const handleMenuClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(rowId);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const StyledGridOverlay = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  }));

  const CustomNoRowsOverlay = () => (
    <StyledGridOverlay>
      <Box sx={{ mt: 1 }}>No Data Found</Box>
    </StyledGridOverlay>
  );

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div>
          {editingId === params.row.id ? (
            <IconButton onClick={handleCancel} color="error">
              <MdClose />
            </IconButton>
          ) : (
            <IconButton onClick={() => handleEdit(params.row)} color="inherit">
              <CiEdit />
            </IconButton>
          )}
        </div>
      ),
    },
    {
      field: "bulk_price",
      headerName: "Bulk",
      align: "top",
      headerAlign: "top",
      flex: 1,
      minWidth: 80,
      renderCell: (params) =>
        editingId === params.row.id ? (
          <input
            type="number"
            value={parseFloat(editValues.bulk_price) || ""}
            onChange={(e) => handleFieldChange("bulk_price", e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          "$ " + formatFloat(params.value)
        ),
    },
    {
      field: "smalls_price",
      headerName: "Smalls",
      align: "top",
      headerAlign: "top",
      flex: 1,
      minWidth: 80,
      renderCell: (params) =>
        editingId === params.row.id ? (
          <input
            type="number"
            value={parseFloat(editValues.smalls_price) || ""}
            onChange={(e) => handleFieldChange("smalls_price", e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          "$ " + formatFloat(params.value)
        ),
    },
    {
      field: "trim_price",
      headerName: "Trim",
      align: "top",
      headerAlign: "top",
      flex: 1,
      minWidth: 80,
      renderCell: (params) =>
        editingId === params.row.id ? (
          <input
            type="number"
            value={parseFloat(editValues.trim_price) || ""}
            onChange={(e) => handleFieldChange("trim_price", e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          "$ " + formatFloat(params.value)
        ),
    },
  ];

  const harvestColumns = [
    {
      field: "action",
      headerName: "Action",
      width: 100,
      align: "top",
      headerAlign: "top",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <>
          {editingHarvestId === params.row.id && params.row.isNew ? (
            <IconButton onClick={handleCancelHarvest} color="error">
              <MdClose />
            </IconButton>
          ) : editingHarvestId === params.row.id ? (
            <IconButton onClick={handleCancelHarvest} color="error">
              <MdClose />
            </IconButton>
          ) : (
            <>
              <IconButton onClick={(e) => handleMenuClick(e, params.row.id)}>
                <GridMoreVertIcon />
              </IconButton>
              {anchorEl && menuRowId === params.row.id && (
                <Popover
                  className="popup-menu"
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={handleCloseMenu}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem
                    onClick={() => {
                      handleEditHarvest(params.row);
                      handleCloseMenu();
                    }}
                    className="menu-list-items"
                  >
                    <div className="menu-list-items-text">Edit</div>
                    <CiEdit style={{ cursor: "pointer" }} />
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSelectedArchiveId(params.row.id);
                      setArchivingType("harvest");
                      setArchiveModalOpen(true);
                      handleCloseMenu();
                    }}
                    className="menu-list-items"
                  >
                    <div className="menu-list-items-text">Archive</div>
                    <MdArchive style={{ cursor: "pointer" }} />
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSelectedDeleteId(params.row.id);
                      setDeletingType("harvest");
                      setDeleteModalOpen(true);
                      handleCloseMenu();
                    }}
                    className="menu-list-items"
                  >
                    <div className="menu-list-items-text">Delete</div>
                    <GoTrash style={{ cursor: "pointer" }} />
                  </MenuItem>
                </Popover>
              )}
            </>
          )}
        </>
      ),
    },
    {
      field: "week_of_harvest",
      headerName: "Week of Harvest",
      flex: 1,
      minWidth: 150,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingHarvestId === params.row.id ? (
          <input
            type="number"
            value={editHarvestValues.week_of_harvest || ""}
            onChange={(e) =>
              handleHarvestFieldChange("week_of_harvest", e.target.value)
            }
            onBlur={(e) =>
              handleHarvestFieldChange("week_of_harvest", e.target.value, false)
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          params.value || "-"
        ),
    },
    {
      field: "harvest_date",
      headerName: "Harvest Date",
      flex: 1,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      minWidth: 200,
      renderCell: (params) =>
        editingHarvestId === params.row.id ? (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={
                editHarvestValues.harvest_date
                  ? dayjs(editHarvestValues.harvest_date)
                  : null
              }
              onChange={(newValue) => {
                const dateValue = newValue ? newValue.format("YYYY-MM-DD") : "";
                handleHarvestFieldChange("harvest_date", dateValue);
              }}
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  onBlur: () =>
                    handleHarvestFieldChange(
                      "harvest_date",
                      editHarvestValues.harvest_date,
                      false,
                    ),
                },
              }}
              disableFuture
            />
          </LocalizationProvider>
        ) : params.value ? (
          dayjs(params.value).format("MM-DD-YYYY")
        ) : (
          "-"
        ),
    },
    {
      field: "cultivar_id",
      headerName: "Cultivar",
      flex: 1,
      minWidth: 180,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingHarvestId === params.row.id ? (
          <FormControl fullWidth size="small">
            <Select
              value={editHarvestValues.cultivar_id || ""}
              onChange={(e) =>
                handleHarvestFieldChange("cultivar_id", e.target.value)
              }
              onBlur={(e) =>
                handleHarvestFieldChange("cultivar_id", e.target.value, false)
              }
              native
            >
              <option value="">Select Cultivar</option>
              {cultivars.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </Select>
          </FormControl>
        ) : (
          params.row.cultivar_name || "-"
        ),
    },
    {
      field: "room_id",
      headerName: "Room",
      flex: 1,
      minWidth: 180,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingHarvestId === params.row.id ? (
          <FormControl fullWidth size="small">
            <Select
              value={editHarvestValues.room_id || ""}
              onChange={(e) =>
                handleHarvestFieldChange("room_id", e.target.value)
              }
              onBlur={(e) =>
                handleHarvestFieldChange("room_id", e.target.value, false)
              }
              native
            >
              <option value="">Select Room</option>
              {rooms.map((r) => (
                <option key={r.id} value={r.id}>
                  {r.name}
                </option>
              ))}
            </Select>
          </FormControl>
        ) : (
          params.row.room_name || "-"
        ),
    },
    {
      field: "plants",
      headerName: "No. of Plants",
      flex: 1,
      minWidth: 120,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingHarvestId === params.row.id ? (
          <input
            type="number"
            value={parseFloat(editHarvestValues.plants) || ""}
            onChange={(e) => handleHarvestFieldChange("plants", e.target.value)}
            onBlur={(e) =>
              handleHarvestFieldChange("plants", e.target.value, false)
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          <span
            style={{
              textDecoration: "underline",
              color: "#427fcfff",
              cursor: "pointer",
              // fontWeight: 600,
            }}
            onClick={() => handleOpenMatricModal(params.row)}
          >
            {parseFloat(params.value) || 0}
          </span>
        ),
    },
    {
      field: "wet_weight",
      headerName: "Wet Weight",
      flex: 1,
      minWidth: 120,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingHarvestId === params.row.id ? (
          <input
            type="number"
            value={parseFloat(editHarvestValues.wet_weight) || ""}
            onChange={(e) =>
              handleHarvestFieldChange("wet_weight", e.target.value)
            }
            onBlur={(e) =>
              handleHarvestFieldChange("wet_weight", e.target.value, false)
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          formatFloat(params.value)
        ),
    },
    {
      field: "waste",
      headerName: "Waste",
      flex: 1,
      minWidth: 100,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingHarvestId === params.row.id ? (
          <input
            type="number"
            value={parseFloat(editHarvestValues.waste) || ""}
            onChange={(e) => handleHarvestFieldChange("waste", e.target.value)}
            onBlur={(e) =>
              handleHarvestFieldChange("waste", e.target.value, false)
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          formatFloat(params.value)
        ),
    },
    {
      field: "total_wet_weight_after_waste",
      headerName: "Total Wet Weight After Waste",
      flex: 1,
      minWidth: 200,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      valueGetter: (params) =>
        formatFloat(params.row.total_wet_weight_after_waste),
    },
    // {
    //   field: "weight_after_bucking",
    //   headerName: "Weight After Bucking",
    //   flex: 1,
    //   minWidth: 180,
    //   headerClassName: "headerclass",
    //   headerAlign: "top",
    //   align: "top",
    //   renderCell: (params) =>
    //     editingHarvestId === params.row.id ? (
    //       <input
    //         type="number"
    //         value={parseFloat(editHarvestValues.weight_after_bucking) || ""}
    //         onChange={(e) =>
    //           handleHarvestFieldChange("weight_after_bucking", e.target.value)
    //         }
    //         onBlur={(e) =>
    //           handleHarvestFieldChange(
    //             "weight_after_bucking",
    //             e.target.value,
    //             false,
    //           )
    //         }
    //         style={{
    //           width: "100%",
    //           padding: "8px",
    //           border: "1px solid #ccc",
    //           borderRadius: "4px",
    //         }}
    //       />
    //     ) : (
    //       formatFloat(params.value)
    //     ),
    // },
    // {
    //   field: "weight_lost_after_bucking",
    //   headerName: "Weight lost after bucking",
    //   flex: 1,
    //   minWidth: 200,
    //   headerClassName: "headerclass",
    //   valueGetter: (params) =>
    //     formatFloat(params.row.weight_lost_after_bucking),
    // },
    {
      field: "total_packaged",
      headerName: "TOTAL PACKAGED",
      flex: 1,
      minWidth: 150,
      headerClassName: "headerclass",
      valueGetter: (params) => formatFloat(params.row.total_packaged),
    },
    {
      field: "bulk_lbs",
      headerName: "Bulk in POUNDS",
      flex: 1,
      minWidth: 150,
      headerClassName: "headerclass",
      renderCell: (params) =>
        editingHarvestId === params.row.id ? (
          <input
            type="number"
            value={parseFloat(editHarvestValues.bulk_lbs) || ""}
            onChange={(e) =>
              handleHarvestFieldChange("bulk_lbs", e.target.value)
            }
            onBlur={(e) =>
              handleHarvestFieldChange("bulk_lbs", e.target.value, false)
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          formatFloat(params.value)
        ),
    },
    {
      field: "smalls_lbs",
      headerName: "Smalls in POUNDS",
      flex: 1,
      minWidth: 160,
      headerClassName: "headerclass",
      renderCell: (params) =>
        editingHarvestId === params.row.id ? (
          <input
            type="number"
            value={parseFloat(editHarvestValues.smalls_lbs) || ""}
            onChange={(e) =>
              handleHarvestFieldChange("smalls_lbs", e.target.value)
            }
            onBlur={(e) =>
              handleHarvestFieldChange("smalls_lbs", e.target.value, false)
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          formatFloat(params.value)
        ),
    },
    {
      field: "trim_lbs",
      headerName: "Trim in POUNDS",
      flex: 1,
      minWidth: 150,
      headerClassName: "headerclass",
      renderCell: (params) =>
        editingHarvestId === params.row.id ? (
          <input
            type="number"
            value={parseFloat(editHarvestValues.trim_lbs) || ""}
            onChange={(e) =>
              handleHarvestFieldChange("trim_lbs", e.target.value)
            }
            onBlur={(e) =>
              handleHarvestFieldChange("trim_lbs", e.target.value, false)
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          formatFloat(params.value)
        ),
    },
    {
      field: "total_lbs_per_plant_avg",
      headerName: "TOTAL lbs per PLANT Average",
      flex: 1,
      minWidth: 200,
      headerClassName: "headerclass",
      valueGetter: (params) => formatFloat(params.row.total_lbs_per_plant_avg),
    },
    {
      field: "bulk_lbs_per_plant_avg",
      headerName: "BULK lbs per PLANT Average",
      flex: 1,
      minWidth: 200,
      headerClassName: "headerclass",
      valueGetter: (params) => formatFloat(params.row.bulk_lbs_per_plant_avg),
    },
    {
      field: "smalls_lbs_per_plant_avg",
      headerName: "SMALLS lbs per PLANT Average",
      flex: 1,
      minWidth: 220,
      headerClassName: "headerclass",
      valueGetter: (params) => formatFloat(params.row.smalls_lbs_per_plant_avg),
    },
    {
      field: "trim_lbs_per_plant_avg",
      headerName: "TRIM lbs per PLANT Average",
      flex: 1,
      minWidth: 200,
      headerClassName: "headerclass",
      valueGetter: (params) => formatFloat(params.row.trim_lbs_per_plant_avg),
    },
    {
      field: "total_value_per_plant_avg",
      headerName: "TOTAL VALUE per PLANT Average",
      flex: 1,
      minWidth: 220,
      headerClassName: "headerclass",
      valueGetter: (params) =>
        "$" + formatFloat(params.row.total_value_per_plant_avg),
    },
    {
      field: "bulk_value_per_plant_avg",
      headerName: "BULK VALUE per PLANT Average",
      flex: 1,
      minWidth: 220,
      headerClassName: "headerclass",
      valueGetter: (params) =>
        "$" + formatFloat(params.row.bulk_value_per_plant_avg),
    },
    {
      field: "smalls_value_per_plant_avg",
      headerName: "SMALLS VALUE per PLANT Average",
      flex: 1,
      minWidth: 240,
      headerClassName: "headerclass",
      valueGetter: (params) =>
        "$" + formatFloat(params.row.smalls_value_per_plant_avg),
    },
    {
      field: "trim_value_per_plant_avg",
      headerName: "TRIM VALUE per PLANT Average",
      flex: 1,
      minWidth: 220,
      headerClassName: "headerclass",
      valueGetter: (params) =>
        "$" + formatFloat(params.row.trim_value_per_plant_avg),
    },
    {
      field: "bulk_percent_per_plant_avg",
      headerName: "% BULK per PLANT Average",
      flex: 1,
      minWidth: 200,
      headerClassName: "headerclass",
      valueGetter: (params) =>
        params.row.bulk_percent_per_plant_avg
          ? (parseFloat(params.row.bulk_percent_per_plant_avg) * 100).toFixed(
              2,
            ) + "%"
          : "0%",
    },
    {
      field: "smalls_percent_per_plant_avg",
      headerName: "% SMALLS per PLANT Average",
      flex: 1,
      minWidth: 220,
      headerClassName: "headerclass",
      valueGetter: (params) =>
        params.row.smalls_percent_per_plant_avg
          ? parseFloat(params.row.smalls_percent_per_plant_avg) * 100 + "%"
          : "0%",
    },
    {
      field: "trim_percent_per_plant_avg",
      headerName: "% TRIM per PLANT Average",
      flex: 1,
      minWidth: 200,
      headerClassName: "headerclass",
      valueGetter: (params) =>
        params.row.trim_percent_per_plant_avg
          ? parseFloat(params.row.trim_percent_per_plant_avg) * 100 + "%"
          : "0%",
    },
  ];

  const frozenHarvestColumns = [
    {
      field: "action",
      headerName: "Action",
      width: 100,
      align: "top",
      headerAlign: "top",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <>
          {editingFrozenHarvestId === params.row.id ? (
            <IconButton
              onClick={handleCancelFrozenHarvest}
              color="error"
              size="small"
            >
              <MdClose />
            </IconButton>
          ) : (
            <>
              <IconButton
                onClick={(e) => handleMenuClickFrozen(e, params.row.id)}
              >
                <GridMoreVertIcon />
              </IconButton>
              {anchorEl && menuRowId === params.row.id && (
                <Popover
                  className="popup-menu"
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={handleCloseMenu}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem
                    onClick={() => {
                      handleEditFrozenHarvest(params.row);
                      handleCloseMenu();
                    }}
                    className="menu-list-items"
                  >
                    <div className="menu-list-items-text">Edit</div>
                    <CiEdit style={{ cursor: "pointer" }} />
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSelectedArchiveId(params.row.id);
                      setArchivingType("frozen");
                      setArchiveModalOpen(true);
                      handleCloseMenu();
                    }}
                    className="menu-list-items"
                  >
                    <div className="menu-list-items-text">Archive</div>
                    <MdArchive style={{ cursor: "pointer" }} />
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSelectedDeleteId(params.row.id);
                      setDeletingType("frozen");
                      setDeleteModalOpen(true);
                      handleCloseMenu();
                    }}
                    className="menu-list-items"
                  >
                    <div className="menu-list-items-text">Delete</div>
                    <GoTrash style={{ cursor: "pointer" }} />
                  </MenuItem>
                </Popover>
              )}
            </>
          )}
        </>
      ),
    },
    {
      field: "week_of_harvest",
      headerName: "Week of Harvest",
      flex: 1,
      minWidth: 150,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingFrozenHarvestId === params.row.id ? (
          <input
            type="number"
            value={editFrozenHarvestValues.week_of_harvest || ""}
            onChange={(e) =>
              handleFrozenHarvestFieldChange("week_of_harvest", e.target.value)
            }
            onBlur={(e) =>
              handleFrozenHarvestFieldChange(
                "week_of_harvest",
                e.target.value,
                false,
              )
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          params.value || "-"
        ),
    },
    {
      field: "harvest_date",
      headerName: "Harvest Date",
      flex: 1,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      minWidth: 200,
      renderCell: (params) =>
        editingFrozenHarvestId === params.row.id ? (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={
                editFrozenHarvestValues.harvest_date
                  ? dayjs(editFrozenHarvestValues.harvest_date)
                  : null
              }
              onChange={(newValue) => {
                const dateValue = newValue ? newValue.format("YYYY-MM-DD") : "";
                handleFrozenHarvestFieldChange("harvest_date", dateValue);
              }}
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  onBlur: () =>
                    handleFrozenHarvestFieldChange(
                      "harvest_date",
                      editFrozenHarvestValues.harvest_date,
                      false,
                    ),
                },
              }}
              disableFuture
            />
          </LocalizationProvider>
        ) : params.value ? (
          dayjs(params.value).format("MM-DD-YYYY")
        ) : (
          "-"
        ),
    },
    {
      field: "cultivar_id",
      headerName: "Cultivar",
      flex: 1,
      minWidth: 180,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingFrozenHarvestId === params.row.id ? (
          <FormControl fullWidth size="small">
            <Select
              value={editFrozenHarvestValues.cultivar_id || ""}
              onChange={(e) =>
                handleFrozenHarvestFieldChange("cultivar_id", e.target.value)
              }
              onBlur={(e) =>
                handleFrozenHarvestFieldChange(
                  "cultivar_id",
                  e.target.value,
                  false,
                )
              }
              native
            >
              <option value="">Select Cultivar</option>
              {cultivars.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </Select>
          </FormControl>
        ) : (
          params.row.cultivar_name || "-"
        ),
    },
    {
      field: "room_id",
      headerName: "Room",
      flex: 1,
      minWidth: 180,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingFrozenHarvestId === params.row.id ? (
          <FormControl fullWidth size="small">
            <Select
              value={editFrozenHarvestValues.room_id || ""}
              onChange={(e) =>
                handleFrozenHarvestFieldChange("room_id", e.target.value)
              }
              onBlur={(e) =>
                handleFrozenHarvestFieldChange("room_id", e.target.value, false)
              }
              native
            >
              <option value="">Select Room</option>
              {rooms.map((r) => (
                <option key={r.id} value={r.id}>
                  {r.name}
                </option>
              ))}
            </Select>
          </FormControl>
        ) : (
          params.row.room_name || "-"
        ),
    },
    {
      field: "plants",
      headerName: "No. of Plants",
      flex: 1,
      minWidth: 120,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingFrozenHarvestId === params.row.id ? (
          <input
            type="number"
            value={parseFloat(editFrozenHarvestValues.plants) || ""}
            onChange={(e) =>
              handleFrozenHarvestFieldChange("plants", e.target.value)
            }
            onBlur={(e) =>
              handleFrozenHarvestFieldChange("plants", e.target.value, false)
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          parseFloat(params.value) || 0
        ),
    },
    {
      field: "wet_weight",
      headerName: "Wet Weight",
      flex: 1,
      minWidth: 120,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingFrozenHarvestId === params.row.id ? (
          <input
            type="number"
            value={editFrozenHarvestValues.wet_weight || ""}
            onChange={(e) =>
              handleFrozenHarvestFieldChange("wet_weight", e.target.value)
            }
            onBlur={(e) =>
              handleFrozenHarvestFieldChange(
                "wet_weight",
                e.target.value,
                false,
              )
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          formatFloat(params.value) || 0
        ),
    },
    {
      field: "waste",
      headerName: "Waste",
      flex: 1,
      minWidth: 100,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      renderCell: (params) =>
        editingFrozenHarvestId === params.row.id ? (
          <input
            type="number"
            value={editFrozenHarvestValues.waste || ""}
            onChange={(e) =>
              handleFrozenHarvestFieldChange("waste", e.target.value)
            }
            onBlur={(e) =>
              handleFrozenHarvestFieldChange("waste", e.target.value, false)
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          formatFloat(params.value) || 0
        ),
    },
    {
      field: "total_wet_weight_after_waste",
      headerName: "Total Wet Weight After Waste",
      flex: 1,
      minWidth: 200,
      headerClassName: "headerclass",
      headerAlign: "top",
      align: "top",
      valueGetter: (params) => {
        const wetWeight = parseFloat(params.row.wet_weight) || 0;
        const waste = parseFloat(params.row.waste) || 0;
        return formatFloat(wetWeight - waste);
      },
    },
    {
      field: "fresh_frozen_grams",
      headerName: "Fresh Frozen Grams",
      flex: 1,
      minWidth: 160,
      headerClassName: "headerclass",
      renderCell: (params) =>
        editingFrozenHarvestId === params.row.id ? (
          <input
            type="number"
            value={editFrozenHarvestValues.fresh_frozen_grams || ""}
            onChange={(e) =>
              handleFrozenHarvestFieldChange(
                "fresh_frozen_grams",
                e.target.value,
              )
            }
            onBlur={(e) =>
              handleFrozenHarvestFieldChange(
                "fresh_frozen_grams",
                e.target.value,
                false,
              )
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          formatFloat(params.value) || 0
        ),
    },
    {
      field: "rosin_grams",
      headerName: "Rosin Grams",
      flex: 1,
      minWidth: 150,
      headerClassName: "headerclass",
      renderCell: (params) =>
        editingFrozenHarvestId === params.row.id ? (
          <input
            type="number"
            value={editFrozenHarvestValues.rosin_grams || ""}
            onChange={(e) =>
              handleFrozenHarvestFieldChange("rosin_grams", e.target.value)
            }
            onBlur={(e) =>
              handleFrozenHarvestFieldChange(
                "rosin_grams",
                e.target.value,
                false,
              )
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          formatFloat(params.value) || 0
        ),
    },
    {
      field: "yield",
      headerName: "Yield",
      flex: 1,
      minWidth: 120,
      headerClassName: "headerclass",
      renderCell: (params) =>
        editingFrozenHarvestId === params.row.id ? (
          <input
            type="number"
            value={
              editFrozenHarvestValues.yield !== null
                ? editFrozenHarvestValues.yield
                : ""
            }
            onChange={(e) =>
              handleFrozenHarvestFieldChange("yield", e.target.value)
            }
            onBlur={(e) =>
              handleFrozenHarvestFieldChange("yield", e.target.value, false)
            }
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ) : (
          formatFloat(params.value) || 0
        ),
    },
  ];

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className="harvest">
        {!hideHeader && (
          <div className="page-title">
            <div className="title-wrap">
              <h1>Harvest</h1>
            </div>
          </div>
        )}

        <div style={{ width: "100%", marginTop: 35 }}>
          <div className="page-title pb-0">
            <div className="title-wrap">
              <h4>Estimated Price Value</h4>
            </div>
          </div>
          <DataGrid
            rows={priceData}
            columns={columns}
            loading={loading}
            autoHeight
            disableRowSelectionOnClick
            sx={{
              border: "1px solid #E0E0E0",
              [`& .${gridClasses.cell}`]: { py: 1 },
              width: "52%",
            }}
            slots={{ noRowsOverlay: CustomNoRowsOverlay }}
            hideFooter
            showCellVerticalBorder
            showColumnVerticalBorder
          />
        </div>

        <div
          ref={gridContainerRef}
          style={{ width: "100%", marginTop: 35 }}
        >
          <div className="page-title">
            <div className="title-wrap"></div>
            <div className="button-wrap">
              {/* <button
                type="button"
                className="btn btn-primary me-2"
                onClick={handleArchiveAll}
              >
                <MdArchive /> Archive
              </button> */}
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleAddHarvest}
              >
                <RxPlus /> Add Harvest
              </button>
            </div>
          </div>
          <div className="frozen-table-wrapper" style={{ width: "100%" }}>
            {/* Fake frozen header */}
            <div className="fake-frozen-header">
              <div
                className="fake-header-cell"
                style={{
                  width: 100,
                  backgroundColor: "#e7e7ff",
                  fontFamily: "inherit",
                  justifyContent: "center",
                }}
              >
                Action
              </div>
            </div>
            <DataGrid
              rows={harvestData}
              columns={harvestColumns}
              loading={loading}
              disableRowSelectionOnClick
              autoHeight={harvestData.length <= 10}
              columnBuffer={harvestColumns.length}
              sx={{
                border: "1px solid #E0E0E0",
                [`& .${gridClasses.cell}`]: { py: 1 },
                maxHeight: 576,
                "& .MuiDataGrid-cell[data-field='action']": {
                  position: "sticky !important",
                  left: "0 !important",
                  zIndex: "2 !important",
                  backgroundColor: "#fff !important",
                  borderRight: "1px solid #E0E0E0 !important",
                  boxShadow: "2px 0 5px -2px rgba(0, 0, 0, 0.2) !important",
                },
                "& .MuiDataGrid-row:hover .MuiDataGrid-cell[data-field='action']": {
                  backgroundColor: "#F5F5F7 !important",
                },
                "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell[data-field='action']": {
                  backgroundColor: "#E6F6F1 !important",
                },
              }}
              slots={{ noRowsOverlay: CustomNoRowsOverlay }}
              hideFooter
              showCellVerticalBorder
              showColumnVerticalBorder
            />
          </div>
        </div>

        <div
          ref={frozenGridContainerRef}
          style={{ width: "100%", marginTop: 35 }}
        >
          <div className="page-title">
            <div className="title-wrap"></div>
            <div className="button-wrap">
              {/* <button
                type="button"
                className="btn btn-primary me-2"
                onClick={handleArchiveAll}
              >
                <MdArchive /> Archive
              </button> */}
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleAddFrozenHarvest}
              >
                <RxPlus /> Add Fresh Frozen
              </button>
            </div>
          </div>
          <div className="frozen-table-wrapper" style={{ width: "100%" }}>
            {/* Fake frozen header */}
            <div className="fake-frozen-header">
              <div
                className="fake-header-cell"
                style={{
                  width: 100,
                  backgroundColor: "#e7e7ff",
                  fontFamily: "inherit",
                  justifyContent: "center",
                }}
              >
                Action
              </div>
            </div>
            <DataGrid
              rows={frozenHarvestData}
              columns={frozenHarvestColumns}
              loading={loading}
              disableRowSelectionOnClick
              autoHeight={frozenHarvestData.length <= 10}
              columnBuffer={frozenHarvestColumns.length}
              sx={{
                border: "1px solid #E0E0E0",
                [`& .${gridClasses.cell}`]: { py: 1 },
                maxHeight: 576,
                "& .MuiDataGrid-cell[data-field='action']": {
                  position: "sticky !important",
                  left: "0 !important",
                  zIndex: "2 !important",
                  backgroundColor: "#fff !important",
                  borderRight: "1px solid #E0E0E0 !important",
                  boxShadow: "2px 0 5px -2px rgba(0, 0, 0, 0.2) !important",
                },
                "& .MuiDataGrid-row:hover .MuiDataGrid-cell[data-field='action']": {
                  backgroundColor: "#F5F5F7 !important",
                },
                "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell[data-field='action']": {
                  backgroundColor: "#E6F6F1 !important",
                },
              }}
              slots={{ noRowsOverlay: CustomNoRowsOverlay }}
              hideFooter
              showCellVerticalBorder
              showColumnVerticalBorder
            />
          </div>
        </div>
      </div>

      <Modal
        open={archiveModalOpen}
        onClose={() => setArchiveModalOpen(false)}
        aria-labelledby="archive-modal-title"
        aria-describedby="archive-modal-description"
      >
        <div className="modal_block">
          <div className="modal_header">
            <div className="modal_title_wrapper">
              <h2 className="modal_title">Are you Sure?</h2>
            </div>
            <div className="cancel-btn-wrap">
              <RxCross1 onClick={() => setArchiveModalOpen(false)} />
            </div>
          </div>
          <div className="modal_content">
            <div className="modal_content_inner">
              <div>
                <TbAlertHexagonFilled />
              </div>
              <div>
                <p>Do you want to archive?</p>
              </div>
            </div>
          </div>
          <div className="modal_footer">
            <button
              onClick={() => setArchiveModalOpen(false)}
              className="btn btn-border"
            >
              No
            </button>
            <button
              onClick={() => {
                if (archivingType === "frozen") {
                  handleArchiveFrozenHarvest(selectedArchiveId);
                } else {
                  handleArchiveHarvest(selectedArchiveId);
                }
                setArchiveModalOpen(false);
                setSelectedArchiveId(null);
              }}
              className="btn btn-primary"
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
      >
        <div className="modal_block">
          <div className="modal_header">
            <div className="modal_title_wrapper">
              <h2 className="modal_title">Are you Sure?</h2>
            </div>
            <div className="cancel-btn-wrap">
              <RxCross1 onClick={() => setDeleteModalOpen(false)} />
            </div>
          </div>
          <div className="modal_content">
            <div className="modal_content_inner">
              <div>
                <TbAlertHexagonFilled />
              </div>
              <div>
                <p>Do you want to delete?</p>
              </div>
            </div>
          </div>
          <div className="modal_footer">
            <button
              onClick={() => setDeleteModalOpen(false)}
              className="btn btn-border"
            >
              No
            </button>
            <button
              onClick={() => {
                if (deletingType === "frozen") {
                  handleDeleteFrozenHarvest(selectedDeleteId);
                } else {
                  handleDeleteHarvest(selectedDeleteId);
                }
                setDeleteModalOpen(false);
                setSelectedDeleteId(null);
              }}
              className="btn btn-primary"
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>

      {/* Matric IDs Modal */}
      <MatricIdsListModal
        open={matricModalOpen}
        handleClose={() => {
          setMatricModalOpen(false);
          setSelectedMatricRow(null);
        }}
        row={selectedMatricRow}
      />
    </>
  );
};

export default Harvest;
